export enum ProcurementTypeEnum {
    CASH = 'cash',
    LOAN = 'loan',
    INVENTORY = 'inventory',
}
